'use strict';

var React = require('react'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    { PropTypes } = React;

require('./AboutSectionGrid.less');

var AboutSectionGrid = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    type: PropTypes.oneOf(['feed', 'zinesLeft', 'zinesRight']).isRequired,
    active: PropTypes.bool,
    imageUrls: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    imageSize: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number
    }).isRequired
  },

  getCSSModifiers() {
    const { type, active } = this.props;

    return {
      inactive: !active,
      [type]: true
    };
  },

  render() {
    return (
      <div className={this.getClassName()}>
        {this.props.imageUrls.map(this.renderItem)}
      </div>
    );
  },

  renderItem(imageUrl, index) {
    const { imageSize } = this.props;

    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    return (
      <div className='AboutSectionGrid-item' key={index}>
        <img {...imageSize}
             style={imageSize}
             src={getThumbnailUrl({ url: imageUrl }, {
              mode: 'preview',
              width: imageSize.width * Math.round(devicePixelRatio),
              height: imageSize.height * Math.round(devicePixelRatio)
            })} />
      </div>
    );
  }
});

module.exports = AboutSectionGrid;



/** WEBPACK FOOTER **
 ** ./organisms/AboutSectionGrid.jsx
 **/